import React from 'react';

const ContentTop = (props) => {
    return (
        <div className="content-top-box">
            {props.children}
        </div>
    );
};

export default ContentTop;